<p-toast />
<p-table
  #installationTbl
  [value]="installationWithCounts()"
  stripedRows
  [paginator]="true"
  [rows]="15"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} installations"
  [rowsPerPageOptions]="[5, 10, 15, 20, 50, 100]"
  [loading]="installationService.isLoading()"
  [globalFilterFields]="['name']"
  size="small"
>
  <ng-template #caption>
    <div class="flex">
      <div class="text-start">
        <p-button
          icon="pi pi-plus"
          label="Add installation"
          (click)="addInstallation()"
        />
      </div>
      <p-iconfield class="ml-auto">
        <p-inputicon class="pi pi-search" />
        <input
          #searchInput
          type="text"
          pInputText
          placeholder="Search"
          (input)="
            installationTbl.filterGlobal($event.target.value, 'contains')
          "
        />
        <p-inputicon
          class="pi pi-times text-red-600 hover:cursor-pointer"
          (click)="searchInput.value = ''; installationTbl.clear()"
        />
      </p-iconfield>
    </div>
  </ng-template>
  <ng-template #header>
    <tr>
      <th pSortableColumn="name">Name <p-sortIcon field="name" /></th>
      <th pSortableColumn="amountOfLinkedBoxes">
        Boxes linked to this installation
        <p-sortIcon field="amountOfLinkedBoxes" />
      </th>
      <th>Visible for ... users</th>
      <th></th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template #body let-installation>
    <tr>
      <td>{{ installation.name }}</td>
      <td>{{ installation.amountOfLinkedBoxes }}</td>
      <td>{{ installation.amountOfAccountsVisible }}</td>
      <td style="width: 4rem">
        <p-button
          icon="pi pi-pencil"
          [rounded]="true"
          [outlined]="true"
          (click)="editInstallation(installation)"
        />
      </td>
      <td style="width: 4rem">
        @if (
          installation.amountOfLinkedBoxes === 0 &&
          installation.id !== 1 &&
          installation.id !== 2 &&
          installation.amountOfAccountsVisible === 0 &&
          isSuperAdmin
        ) {
          <p-button
            icon="pi pi-trash"
            [rounded]="true"
            [outlined]="true"
            (click)="deleteInstallation(installation)"
          />
        }
      </td>
    </tr>
  </ng-template>
</p-table>
<p-dialog
  [(visible)]="installationDialog"
  [style]="{ width: '450px' }"
  header="Installation Details"
  [modal]="true"
>
  <ng-template #content>
    <div class="flex flex-col gap-6">
      <div>
        <label for="name" class="block font-bold mb-3">Name</label>
        <input
          type="text"
          pInputText
          id="name"
          [(ngModel)]="installation.name"
          required
          autofocus
          fluid
        />
        @if (submitted && installation && !installation.name) {
          <small class="text-red-500">Name is required.</small>
        }
      </div>
      <div>
        <label for="boxes" class="block font-bold mb-3">Linked boxes</label>
        @if (installation.id === 0) {
          <p-multiselect
            [options]="controllersWithDisplayLabelAndUnused()"
            [(ngModel)]="installation.box_ids"
            optionLabel="displayLabel"
            optionValue="ID"
            placeholder="Select boxes"
            class="w-full"
            appendTo="body"
          />
        } @else {
          <p-multiselect
            [options]="controllersWithDisplayLabel()"
            [(ngModel)]="installation.box_ids"
            optionLabel="displayLabel"
            optionValue="ID"
            placeholder="Select boxes"
            class="w-full"
            appendTo="body"
          />
        }
      </div>
      <div>
        <span class="block font-bold mb-4"
          >Visible for the following users</span
        >
        <div class="col-span-12 flex items-center gap-2 mb-2">
          <p-checkbox
            inputId="selectAllUsers"
            [binary]="true"
            [(ngModel)]="allUsersSelected"
            (onChange)="toggleSelectAllUsers()"
          />
          <label for="selectAllUsers"><strong>Select All</strong></label>
        </div>
        <div class="grid grid-cols-12 gap-4">
          @for (user of userService.basicUsers(); track user.id) {
            <div class="flex items-center gap-2 col-span-6">
              <p-checkbox
                inputId="user{{ user.id }}"
                name="group"
                [value]="user.id"
                [(ngModel)]="installation.user_ids"
                (onChange)="updateSelectAllState()"
              />
              <label for="user{{ user.id }}"> {{ user.username }} </label>
            </div>
          }
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #footer>
    <p-button label="Cancel" icon="pi pi-times" text (click)="hideDialog()" />
    <p-button label="Save" icon="pi pi-check" (click)="saveInstallation()" />
  </ng-template>
</p-dialog>
